module.exports = __webpack_public_path__ + "img/RCREG.b90989e5.svg";